import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'
const tabVariants = cva(
  "cursor-pointer data-[state=active]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring inline-flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-0.75 focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50  [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 hover:text-foreground",
  {
    variants: {
      variant: {
        default: '',
        nav: 'font-normal h-10 leading-7 py-1.5 after:content-[""] after:absolute after:-bottom-3 after:left-1/2 after:-translate-x-1/2 after:w-2 after:h-1 after:rounded-lg hover:text-foreground relative text-base px-0 data-[state=active]:after:bg-accent data-[state=active]:text-foreground data-[state=active]:font-bold hover:bg-hover active:bg-active px-2',
        outline:
          'font-normal px-4 h-8 hover:text-accent hover:border-accent text-foreground border border-hover bg-hover  data-[state=active]:border-accent data-[state=active]:text-accent data-[state=active]:bg-accent/10',
      },
      defaultVariants: {
        variant: 'default',
      },
    },
  },
)

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root data-slot="tabs" className={cn('flex flex-col gap-2', className)} {...props} />
}

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn('bg-background text-muted-foreground-2 inline-flex w-fit items-center justify-center rounded-lg', className)}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger> & VariantProps<typeof tabVariants>) {
  return <TabsPrimitive.Trigger data-slot="tabs-trigger" className={cn(tabVariants({ variant, className }))} {...props} />
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn('flex-1 outline-none', className)} {...props} />
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
